import React, { useRef, useMemo } from 'react';
import Modal from 'react-modal';

import { RefuellingReceipt } from './RefuellingReceipt';

import { useStore } from '../../context/Store';

import * as Style from './styles';
import { useReactToPrint } from 'react-to-print';

interface NotificationProps {
  shouldRefreshPageOnClose?: boolean;
}

export const Notification = ({
  shouldRefreshPageOnClose = false,
}: NotificationProps) => {
  const {
    modalIsOpen,
    changeModalIsOpen,
    typeModal,
    titleModal,
    refuellingData,
    resetRefuelingData,
  } = useStore();

  const componentRef = useRef(null);
  const htmlReceipt = useMemo(() => {
    if (refuellingData && 'comprovante' in refuellingData) {
      return (refuellingData as { comprovante: string }).comprovante;
    }
    if (refuellingData && 'htmlReceipt' in refuellingData) {
      return (refuellingData as { htmlReceipt: string }).htmlReceipt;
    }
    return null;
  }, [refuellingData]);

  const decodedHtml = useMemo(() => {
    if (!htmlReceipt) return null;
    const txt = document.createElement('textarea');
    txt.innerHTML = htmlReceipt;
    let html = txt.value;

    // Apply exact same structure as old modal
    html = html
      .replace(/max-width:\s*380px/g, 'max-width: 100%')
      .replace(/padding:\s*1rem/g, 'padding: 1.5rem')
      .replace(/margin:\s*0\s*auto/g, 'margin: 0 auto')
      .replace(/#fff9e6/g, '#fff2cd')
      .replace(
        /border-top:\s*1px\s*dotted\s*#666/g,
        'border-top: 1px dashed #666',
      )
      .replace(
        /<\/style>/,
        `@media print {
          .comprovante-container {
            max-height: 100% !important;
            background: #fff2cd !important;
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
        }
        </style>`,
      );

    return html;
  }, [htmlReceipt]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleHtmlPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '19px',
      background: typeModal === 'error' ? '#CE0000' : '#008D0E',
      zIndex: 9999,
    },
  };

  const hasRefuellingData = refuellingData != null;

  const closeModal = () => {
    changeModalIsOpen(false);
    resetRefuelingData();

    if (shouldRefreshPageOnClose) {
      window.location.reload();
    }
  };
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <Style.TitleModal>{titleModal}</Style.TitleModal>

      {hasRefuellingData && htmlReceipt ? (
        <div
          style={{
            padding: '0.875rem',
            maxHeight: '400px',
            background: 'white',
            overflowY: 'auto',
          }}
        >
          <div
            ref={componentRef}
            dangerouslySetInnerHTML={{ __html: decodedHtml || '' }}
            style={{
              padding: '1.5rem',
              border: '1px dashed #008d0e',
              background: '#fff2cd',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          />
        </div>
      ) : hasRefuellingData ? (
        <RefuellingReceipt ref={componentRef} refuellingData={refuellingData} />
      ) : null}

      {hasRefuellingData ? (
        <Style.ButtonsModalContainer>
          <Style.ButtonModal autoFocus onClick={closeModal}>
            OK, FECHAR
          </Style.ButtonModal>
          <Style.ButtonModal
            onClick={htmlReceipt ? handleHtmlPrint : handlePrint}
          >
            IMPRIMIR
          </Style.ButtonModal>
        </Style.ButtonsModalContainer>
      ) : (
        <Style.ButtonModal autoFocus onClick={closeModal}>
          OK
        </Style.ButtonModal>
      )}
    </Modal>
  );
};
